import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IRegisterItemAttachmentsResult } from './IRegisterItemAttachmentsResult'
import { RegisterItemPropertiesAttachments } from './RegisterItemPropertiesAttachments'

export class RegisterItemAttachmentsResult extends Entity<IRegisterItemAttachmentsResult> {
  @Type(() => RegisterItemPropertiesAttachments)
  propertiesAttachments: RegisterItemPropertiesAttachments[]

  public getTotalAttachmentCount(): number {
    return (
      this.propertiesAttachments?.reduce(
        (total, property) => total + (property.attachments?.length ?? 0),
        0,
      ) ?? 0
    )
  }

  public static new(payload: unknown): RegisterItemAttachmentsResult {
    return plainToInstance(RegisterItemAttachmentsResult, payload)
  }
}
